import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateRule } from 'api/wage/updateRule'
import { wageRuleKeys } from './keys'

export const useUpdateRuleMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof updateRule>[0]) =>
      updateRule(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: wageRuleKeys.all })
    },
  })
}
